import "shared/styles/Home.css";

import React, {useState} from "react";
import {useParams} from "react-router-dom";

import {User} from "../types";
import UserList from "../components/UserList";
import UserDetails from "../components/UserDetails";

const UsersPage = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [activeUser, setActiveUser] = useState<User|undefined>(undefined);
    const { user_id } = useParams<{ user_id: string|undefined }>();
    
    return (
        <div className="main-area">
            <div className="cat-list-sidebar"><UserList users={users} setUsers={setUsers} activeUser={activeUser} setActiveUser={setActiveUser} url_user_id={user_id}/></div>
            <div className="main">
                <UserDetails setUserList={setUsers} activeUser={activeUser} setActiveUser={setActiveUser} />
            </div>
        </div>
    );
};

export default UsersPage;